module.exports = __webpack_public_path__ + "img/Contact-Ticket.svg";


//////////////////
// WEBPACK FOOTER
// ./img/Contact-Ticket.svg
// module id = 245
// module chunks = 0